import Swiper from 'swiper/bundle'

if ($('.js-sliderThumbs').length > 0) {
  $(window).on('load', function() {
    const sliderBottom = new Swiper('.js-sliderThumbs .slider-thumbs__bottom', {
      spaceBetween: 2,
      slideToClickedSlide: true,
      touchRatio: 0.2,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerView: 4,
      breakpoints: {
        768: {
          slidesPerView: 7,
          spaceBetween: 4
        },
      }
    })

    $('.js-sliderThumbs .swiper-slide:first-child').addClass('active');

    const sliderTop = new Swiper('.js-sliderThumbs .slider-thumbs__top', {
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideNextTransitionStart: function () {
          const index = sliderTop.realIndex;
          const currentSlide = sliderBottom.slides[index];

          $(sliderBottom.slides).each(function() {
            $(this).removeClass('active');
          })

          $(currentSlide).addClass('active');

          sliderBottom.slideNext()
        },
        slidePrevTransitionStart: function () {
          const index = sliderTop.realIndex;
          const currentSlide = sliderBottom.slides[index];

          $(sliderBottom.slides).each(function() {
            $(this).removeClass('active');
          })

          $(currentSlide).addClass('active');

          sliderBottom.slidePrev()
        }
      }
    })

    $('.js-sliderThumbs .slider-thumbs__bottom .swiper-slide').on('click', (e) => {
      const index = $(e.currentTarget).index();

      sliderTop.slideTo(index)
    })
  })
}
